import React, { createContext, useContext, useEffect, useState } from "react";

const DarkModeContext = createContext();

export const DarkModeProvider = ({ children }) => {
  const [darkmode, setDarkmode] = useState(false);

  // Load dark mode from localStorage on mount
  useEffect(() => {
    const storedMode = localStorage.getItem("darkmode");
    if (storedMode === "true") {
      setDarkmode(true);
      document.body.classList.add("dark");
    }
  }, []);

  const toggleDarkmode = () => {
    setDarkmode((prev) => {
      const newMode = !prev;
      localStorage.setItem("darkmode", newMode);
      if (newMode) {
        document.body.classList.add("dark");
      } else {
        document.body.classList.remove("dark");
      }
      return newMode;
    });
  };

  return (
    <DarkModeContext.Provider value={{ darkmode, toggleDarkmode }}>
      {children}
    </DarkModeContext.Provider>
  );
};

// Custom hook to use context
export const useDarkMode = () => useContext(DarkModeContext);
